import OrderApi from '@apis/order/OrderApi';
import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { useFlow } from '@router/stackflow';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

function useCancelOrder(orderNo: string) {
  const { pop } = useFlow();
  const toast = useToast();
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: OrderApi.cancelOrder,
    onSuccess() {
      pop();
      toast.info('주문이 취소되었습니다.');
      queryClient.invalidateQueries({ queryKey: queries.orders._def });
      queryClient.invalidateQueries({ queryKey: queries.orderLog._def });
      queryClient.invalidateQueries({ queryKey: queries.user._def });
    },
    onError(e: AxiosError<ErrorResponse>) {
      toast.error(e.response?.data.message || '주문 취소에 실패했습니다.');
    },
  });
  return () => mutate(orderNo);
}

export default useCancelOrder;
